import { render, staticRenderFns } from "./BusinessUnitList.vue?vue&type=template&id=b62d8e90&"
import script from "./BusinessUnitList.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports